module.exports = __webpack_public_path__ + "static/media/研报畅读@2x.fc4a797e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_172/images/研报畅读@2x.png
// module id = 1565
// module chunks = 0